import React from "react";
import { Link } from "react-router-dom";
import AllEventsIcon from "../icons/all-events.svg";
import { ALL_EVENTS_URL, tileClassName } from "./serviceData";
import "../serviceentry.css";
import "./options.css";

export function TileFace({ item, children }) {
  return (
    <>
      {item.groupEvent && <span className="service-entry-card-tag">Group</span>}
      {item.icon && (
        <span className="service-entry-card-icon">
          <img src={item.icon} alt="" />
        </span>
      )}
      <span className="service-entry-card-title">{item.label}</span>
      {children}
    </>
  );
}

/*
 * Tile used by Options One and Two: same behaviour as the live page.
 * Split tiles (30 / 60 Min, Upcoming / Past) show their choices as links.
 */
export function ServiceTile({ item, children }) {
  if (item.options) {
    return (
      <div className={tileClassName(item, ["service-entry-tile--split"])}>
        {item.groupEvent && <span className="service-entry-card-tag">Group</span>}
        <div className="split-tile-header">
          {item.icon && (
            <span className="service-entry-card-icon">
              <img src={item.icon} alt="" />
            </span>
          )}
          <span className="service-entry-card-title">{item.label}</span>
          {children}
        </div>
        <div className="split-tile-options">
          {item.options.map((opt) => (
            <Link
              key={opt.label}
              className="split-tile-option"
              to={opt.to}
              onClick={opt.onClick}
            >
              {opt.label}
            </Link>
          ))}
        </div>
      </div>
    );
  }

  if (item.disabled || !item.to) {
    return (
      <div className={tileClassName(item)} aria-disabled="true">
        <TileFace item={item}>{children}</TileFace>
      </div>
    );
  }

  return (
    <Link className={tileClassName(item)} to={item.to} onClick={item.onClick}>
      <TileFace item={item}>{children}</TileFace>
    </Link>
  );
}

export function ServiceEntryShell({ variant, hint, children, aside }) {
  return (
    <div className={`service-entry-shell se-opt se-opt-${variant}`}>
      <div className="service-entry-intro">
        <h1>Choose the next step in your journey</h1>
        {hint && <p className="se-opt-hint">{hint}</p>}
      </div>

      <div className="service-entry-board">
        <div className="se-opt-layout">
          <div className="se-opt-main">
            {children}
            <Link className="service-entry-all-events" to={ALL_EVENTS_URL}>
              <span className="service-entry-card-icon service-entry-card-icon--all">
                <img src={AllEventsIcon} alt="" />
              </span>
              <span>All Above Group Events</span>
            </Link>
          </div>
          {aside}
        </div>
      </div>
    </div>
  );
}
